export default {
  common: {
    submitBtn: 'Confirmar',
    cancelBtn: 'Cancelar',
    condition: 'Condición',
    display: 'Mostrar',
    hide: 'Ocultar'
  },
  tip: {
    select: 'Por favor, seleccione',
    input: 'Por favor, ingrese'
  },
  check: {
    checkAll: 'Seleccionar todo'
  },
  upload: {
    upload: 'Haga clic para subir',
    tip: 'Arrastra el archivo aquí, o'
  },
  time: {
    start: 'Inicio',
    end: 'Fin'
  },
  date: {
    start: 'Inicio',
    end: 'Fin',
    t: 'Hoy',
    y: 'Ayer',
    n: 'Últimos 7 días',
    a: 'Todo'
  },
  form: {
    printBtn: 'Imprimir',
    mockBtn: 'Simular',
    submitBtn: 'Enviar',
    emptyBtn: 'Vaciar'
  },
  crud: {
    excel: {
      name: 'Nombre del archivo',
      type: 'Datos',
      typeDic: {
        true: 'Datos actuales (todos los datos de la página actual)',
        false: 'Datos seleccionados (datos seleccionados de la página actual)'
      },
      prop: 'Campo',
      params: 'Parámetros',
      paramsDic: {
        header: 'Encabezado',
        data: 'Fuente de datos',
        headers: 'Encabezados complejos',
        sum: 'Resumen estadístico'
      }
    },
    filter: {
      addBtn: 'Agregar condición',
      clearBtn: 'Borrar datos',
      resetBtn: 'Restablecer condición',
      cancelBtn: 'Cancelar',
      submitBtn: 'Confirmar'
    },
    column: {
      name: 'Nombre de columna',
      hide: 'Ocultar',
      fixed: 'Congelado',
      filters: 'Filtrar',
      sortable: 'Ordenable',
      index: 'Orden',
      width: 'Ancho'
    },
    emptyText: 'No hay datos disponibles',
    tipStartTitle: 'Se han seleccionado en la tabla actual',
    tipEndTitle: 'ítems',
    editTitle: 'Editar',
    copyTitle: 'Copiar',
    addTitle: 'Agregar',
    viewTitle: 'Ver',
    filterTitle: 'Condiciones de filtro',
    showTitle: 'Mostrar/Ocultar columnas',
    menu: 'Operaciones',
    addBtn: 'Agregar',
    show: 'Mostrar',
    hide: 'Ocultar',
    open: 'Expandir',
    shrink: 'Contraer',
    printBtn: 'Imprimir',
    mockBtn: 'Simular',
    excelBtn: 'Exportar',
    updateBtn: 'Actualizar',
    cancelBtn: 'Cancelar',
    searchBtn: 'Buscar',
    emptyBtn: 'Vaciar',
    menuBtn: 'Funciones',
    saveBtn: 'Guardar',
    viewBtn: 'Ver',
    editBtn: 'Editar',
    copyBtn: 'Copiar',
    delBtn: 'Eliminar'
  }
};
